import { useMutation } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

const useRemoveCurriculum = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutation({
    mutationFn: (id: string) => httpService.panel.panelCurriculumsDestroy(id),
    onSuccess,
    onError
  })

export default useRemoveCurriculum
